import { i18n } from '@/i18n/translations';
import { App } from 'vue';

export default function (app: App): void {
  app.use(i18n);
}
